import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody31.css';

import clientimg from '../images/case-study-client31.webp'
import outcome from '../images/outcome31.webp'

import sm1 from '../images/cs31so1.webp'
import sm2 from '../images/cs31so2.webp'
import sm3 from '../images/cs31so3.webp'
import sm4 from '../images/cs31so4.webp'
import sm5 from '../images/cs31so5.webp'


const Casestudybody31 = () => {

    return (
        <>
        <section className='casestudybody31-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A family office that has grown into a diversified investment management firm with holdings across real estate, private equity, public equity, and private credit</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client sought to systematically evaluate public equity opportunities within to guide future capital allocation. The goal was to identify high-potential industries and companies based on a mix of fundamental strength, market attractiveness, and technical positioning</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody31-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                  
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Industry Research and Data Collection:</h4>
                          <p>Conducted <span style={{color:"#01C6B2"}}> detailed market research and due diligence</span> across 21 key industries </p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Multi-Parameter Screening:</h4>
                          <p>Assessed industries and companies based on <span style={{color:"#01C6B2"}}>fundamental metrics</span> (growth, profitability, valuation), <span style={{color:"#01C6B2"}}>qualitative factors</span> (competitive landscape, regulatory tailwinds), and <span style={{color:"#01C6B2"}}>technical indicators</span> (price trends, momentum)</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Client Collaboration:</h4>
                          <p>Worked closely with client teams to <span style={{color:"#01C6B2"}}>refine criteria and customize the screener</span> to fit the investment strategy</p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Dashboard Development:</h4>
                          <p>Designed an intuitive <span style={{color:"#01C6B2"}}>dashboard to visualize industry rankings, attractiveness scores, and company-specific insights</span> for easy decision-making</p>
                        </div>
                      </div>                 
                     
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                        <img src={sm5} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody31-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client effectively leveraged the Public Equity Industry Screener to identify lucrative sectors and prioritize investments. The tool provided a structured, data-driven approach to portfolio allocation, improving both decision-making speed and quality</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody31
